import React from "react";
import { Link } from "react-router-dom";
import "./successfullReview.css";
import { useNavigate } from "react-router-dom";

const SuccessfullReview = ({ homework_id1 }) => {
  const navigate = useNavigate()
  console.log(homework_id1);
  return (
    <div className=" successful_preview_transprant_bodyHW">
      <div className=" p-2 successful_preview_container shadow">
        <img src="/images/GreenTick.svg" alt="" />
        <span className=" my-4 successfully_message">
          You have successfully reviewed student homework
        </span>
        <Link to="/PublishedHomework">
          <button className="successfull_okay_btn" onClick={() => {
            navigate('/onreviewstudentlistHW', { state: { homework_id: homework_id1 } })
          }}>Okay</button>
        </Link>
      </div>
    </div>
  );
};

export default SuccessfullReview;
